import Path from "src/constants/path";

export const getAppPathFromUrl = (url: string): string | undefined => {
  const { pathname, search, hash } = new URL(url);
  const isAppPath =
    pathname === `/${Path.app}` || pathname.startsWith(`/${Path.app}/`);
  return isAppPath ? `${pathname}${search}${hash}` : undefined;
};
